import React from "react";
import Meteo from "./Meteo";
import About from "./About";
import Contact from "./Contact";
import OtherMeteo from "./OtherMeteo";

const Body = () => {
  let Component;
  console.log("Current path:", window.location.pathname);
  switch (window.location.pathname) {
    case "/WeatherApp":
      Component = Meteo;
      break;
    case "/WeatherApp/about":
      Component = About;
      break;
    case "/WeatherApp/contact":
      Component = Contact;
      break;
    case "/WeatherApp/weather":
      Component = OtherMeteo;
      break;
    default:
      Component = Meteo; // Fallback to Home if no match
  }
  return (
    <div style={{ minHeight: "50%" }}>
      <Component />
    </div>
  );
};

export default Body;
